export type VideoConstraintsResolution = {
  width: number;
  height: number;
};

export type VideoConstraints = VideoConstraintsResolution & {
  deviceId?: ConstrainDOMString;
};

export const HD_VIDEO_CONSTRAINTS: VideoConstraintsResolution = {
  width: 1280,
  height: 720,
};
